import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
  passwordUpdate,
  resetUpdatePassword
} from '../features/profile/profileSlice';
import { IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import { Icon } from '@iconify/react';

const schema = Yup.object().shape({
  password: Yup.string().required('Current password is required'),
  newPassword: Yup.string()
    .required('New password is required')
    .min(8, 'New password must be at least 8 characters'),
  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
});

const PasswordUpdateForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const {
    isSuccessUpdatePassword,
    isErrorUpdatePassword,
    isLoadingUpdatePassword,
    messageUpdatePassword
  } = useSelector(state => state.profile);
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false
  });

  const handleClickShowPassword = name =>
    setShowPassword({
      ...showPassword,
      [name]: !showPassword[name]
    });

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  const handleMouseUpPassword = event => {
    event.preventDefault();
  };
  const dispatch = useDispatch();

  useEffect(() => {
    if (isErrorUpdatePassword) {
      toast.error(messageUpdatePassword);
    }

    if (isSuccessUpdatePassword) {
      toast.success('Pasword berhasil diperbarui');
      reset();
    }
    dispatch(resetUpdatePassword());
  }, [
    isErrorUpdatePassword,
    isSuccessUpdatePassword,
    dispatch,
    messageUpdatePassword,
    reset
  ]);

  const onSubmit = (data, e) => {
    e.preventDefault();
    dispatch(passwordUpdate(data));
  };

  const renderPasswordField = ({
    id,
    label,
    showKey,
    error,
    placeholder
  }) => (
    <div className='sb-form__field'>
      <label className='sb-form__label' htmlFor={id}>
        {label}
      </label>
      <OutlinedInput
        placeholder={placeholder}
        type={showPassword[showKey] ? 'text' : 'password'}
        size='small'
        id={id}
        name={id}
        {...register(id)}
        className={`sb-form__mui-input${error ? ' is-error' : ''}`}
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              aria-label={
                showPassword[showKey]
                  ? 'hide the password'
                  : 'display the password'
              }
              onClick={() => handleClickShowPassword(showKey)}
              onMouseDown={handleMouseDownPassword}
              onMouseUp={handleMouseUpPassword}
              edge='end'>
              {showPassword[showKey] ? (
                <Icon icon='solar:eye-closed-bold' width={18} color='#6D6D6D' />
              ) : (
                <Icon icon='solar:eye-bold' width={18} color='#6D6D6D' />
              )}
            </IconButton>
          </InputAdornment>
        }
      />
      {error && <p className='sb-form__error'>{error.message}</p>}
    </div>
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)} className='sb-form profile-password'>
      {renderPasswordField({
        id: 'password',
        label: 'Password',
        showKey: 'currentPassword',
        error: errors.password,
        placeholder: 'Masukkan password saat ini'
      })}
      {renderPasswordField({
        id: 'newPassword',
        label: 'Password Baru',
        showKey: 'newPassword',
        error: errors.newPassword,
        placeholder: 'Masukkan password baru'
      })}
      {renderPasswordField({
        id: 'confirmPassword',
        label: 'Konfirmasi Password',
        showKey: 'confirmPassword',
        error: errors.confirmPassword,
        placeholder: 'Konfirmasi password baru'
      })}

      <div className='sb-form__actions'>
        <button
          type='submit'
          className='sb-btn sb-btn--primary'
          disabled={isLoadingUpdatePassword}>
          {isLoadingUpdatePassword ? 'Loading...' : 'Update Kata Sandi'}
        </button>
      </div>
    </form>
  );
};

export default PasswordUpdateForm;
